module.exports = __webpack_public_path__ + "img/intro-connection-light.c98cc75f.jpg";